import React from "react"
import { Link } from "gatsby"
import Logo from "../images/logo.svg"
import styled from "styled-components"
const HeaderWrapper = styled.header`
  height: 70px;
  color: white;
  background-color: white;
  -webkit-box-shadow: -1px -5px 34px -7px rgba(66,66,66,1);
  -moz-box-shadow: -1px -5px 34px -7px rgba(66,66,66,1);
  box-shadow: -1px -5px 34px -7px rgba(66,66,66,1);
  position: fixed;
  width: 100%;
  margin-top: -100px;
  z-index: 103;
  padding: 5px 0px 0px 0px;
  a:hover {
    color: ${props => props.theme.colors.blue};
  }
  ul {
    margin-top: 5px;
    margin-right: 10rem;
    list-style: none;
    overflow: hidden;
    background: transparent;
    @media (max-width: 600px) {
      margin-right: 0;
    }
  }
  li a {
    color: ${props => props.theme.colors.black};
    display: block;
    padding: 15px 15px;
  }
  .logo {
    margin-left: 10px;
    display: block;
    float: left;
    height: 55px;
    text-decoration: none;
    margin-top: 20px;
    width: 250px;
  }
  .menu {
    float: left;
    width: 100%;
    padding: 1px;
    margin-top: -10px;
    background: white;
    background-color: white;
    font-size: 0.9em;
    clear: both;
    max-height: 0px;
    transition: max-height 0.2s ease-out;
  }
  .menu-icon {
    float: right;
    cursor: pointer;
    display: inline-block;
    margin-top: 10px;
    padding: 32px 15px 0px 20px;
    position: relative;
    user-select: none;
  }
  .menu-icon .navicon {
    background: ${props => props.theme.colors.black};
    display: block;
    height: 2px;
    position: relative;
    transition: background 0.2s ease-out;
    width: 18px;
  }
  .menu-icon .navicon:before,
  .menu-icon .navicon:after {
    background: ${props => props.theme.colors.black};
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    transition: all 0.2s ease-out;
    width: 100%;
  }
  .menu-icon .navicon:before {
    top: 5px;
  }
  .menu-icon .navicon:after {
    top: -5px;
  }
  .menu-btn {
    display: none;
  }
  .menu-btn:checked ~ .menu {
    max-height: 370px;
  }
  .menu-btn:checked ~ .menu-icon .navicon {
    background: transparent;
  }
  .menu-btn:checked ~ .menu-icon .navicon:before {
    transform: rotate(-45deg);
  }
  .menu-btn:checked ~ .menu-icon .navicon:after {
    transform: rotate(45deg);
  }
  .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
  .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
    top: 0;
  }
  @media (min-width: 72em) {
    li {
      float: left;
    }
    li a {
      color: ${props => props.theme.colors.black};
      font-weight: 500;
      text-decoration: none;
      position: relative;
      transition: all 0.3s ease;
      margin: 19px 25px;
      padding: 0.2rem 0.4rem;
      z-index: 10;
    }
  
    .menu {
      clear: none;
      float: right;
      max-height: none;
      float: right;
      width: auto;
      background: transparent;
      margin-top: 5px;
    }
    .menu-icon {
      display: none;
    }
    .logo {
      display: block;
      float: left;
      margin-left: 9rem;
      text-decoration: none;
    }
  }
`
const NavButton = styled.button`
  margin-top:13px;
  background-color: ${props => props.theme.colors.blue};
  border: 1px solid ${props => props.theme.colors.blue};
  -webkit-box-shadow: 0px 2px 5px -2px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 2px 5px -2px rgba(0,0,0,0.75);
  box-shadow: 0px 2px 5px -2px rgba(0,0,0,0.75);
  color: white;
  height: 4rem;
  font-weight: 600;
  width: 150px;
  max-width: 100%;
  :hover{
    box-shadow:none;
  }
`

const Header = () => (
  <HeaderWrapper>
    <div className="logo">
      <Link to="/">
        <div>
          <img
            src={Logo}
            title="Konya İnşaat Firması Logo"
            alt="Konya ev tadilatı, konya ofis tadilatı, konya boya badana, konya anahtar teslim inşaat, konya villa tadilatı, konya banyo tadilatı, konya asma tavan, konya alçıpan asma tavan, konya inşaat işleri, konya mutfak tadilatı, konya metal asma tavan, konya alçıpan bölme duvar, konya yıkım işleri, konya duvar kağıtları"
          />
        </div>
      </Link>
    </div>
    <input className="menu-btn" type="checkbox" id="menu-btn" />
    <label className="menu-icon" htmlFor="menu-btn">
      <span className="navicon"></span>
    </label>
    <ul className="menu">
      <li>
        <Link to="/">ANASAYFA</Link>
      </li>
      <li>
        <Link to="/kurumsal">KURUMSAL</Link>
      </li>
      <li>
        <Link to="/hizmetler">HİZMETLERİMİZ</Link>
      </li>
      <Link to="/iletisim">
        <li>
          <NavButton>İLETİŞİM</NavButton>
        </li>
      </Link>
    </ul>
  </HeaderWrapper>
)

export default Header